import { DynamicField, DynamicForm, FieldVariant, SelectFieldProps, SelectOption } from '@/components/form-builder/form-builder.types';
import { DynaDocsModelStatusRepository } from '@/store/dac-general-params-state/dyna-docs-model-status-state/dyna-docs-model-status.repository';
import { ParamGeneralStatus } from '@/types';

interface GetDynaDocsModelStatusFormObjectProps {
  store: DynaDocsModelStatusRepository;
  dynaDocsModelOptions: SelectOption[];
}

export const getDynaDocsModelStatusFormObject = ({ store, dynaDocsModelOptions }: GetDynaDocsModelStatusFormObjectProps): DynamicForm => {
  const dynaDocsModelField: DynamicField<SelectFieldProps> = {
    label: 'dacGeneralParams.form.dynaDocsModel',
    variant: FieldVariant.SELECT,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'dynaDocsModelId'),
    props: {
      placeholder: 'dacGeneralParams.form.dynaDocsModelPlaceholder',
      options: dynaDocsModelOptions,
      value: store.getObservable('dynaDocsModelSelected'),
      onSelectChange: (value: SelectOption) => {
        store.setNested('dto', 'dynaDocsModelId', value.code as number);
        store.set('dynaDocsModelSelected', value);
        store.clearError('dynaDocsModelId');
      },
      filterEnabled: true,
    },
  };

  const statusOptions: SelectOption[] = [
    { name: 'Actif', code: ParamGeneralStatus.ACTIF },
    { name: 'Non Actif', code: ParamGeneralStatus.NON_ACTIF },
  ];

  const statusField: DynamicField<SelectFieldProps> = {
    label: 'dacGeneralParams.form.status',
    variant: FieldVariant.SELECT,
    isRequired: true,
    props: {
      placeholder: 'dacGeneralParams.form.statusPlaceholder',
      options: statusOptions,
      value: store.getObservable('statusSelected'),
      onSelectChange: (value: SelectOption) => {
        store.setNested('dto', 'paramGeneralStatus', value.code as ParamGeneralStatus);
        store.set('statusSelected', value);
      },
    },
  };

  return {
    title: '',
    description: '',
    class: 'p-4',
    isHeaderHidden: true,
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [dynaDocsModelField, statusField],
          },
        ],
      },
    ],
  };
};
